import {Component, OnInit} from '@angular/core';
import {CpProvisionContractAgentBaseComponent} from '../base/cp-provision-contract-agent-base.component';

/**
 * Side view of the Provisionssatz OBC (`uiMode = 'side' | 'mini-side'`).
 *
 * Shape of `cp-provision-agent-side.component.ts`. The side panel is deliberately narrow: the
 * default shows identity, money and liability underneath each other, because that is what a
 * caseworker needs while a worklist stays visible next to it. The wide blocks (bookings, the
 * contract overview) are still reachable through `?sideNavItem=`.
 */
@Component({
    selector: 'cp-provision-contract-agent-side',
    templateUrl: './cp-provision-contract-agent-side.component.html',
    styleUrls: ['./cp-provision-contract-agent-side.component.scss'],
    standalone: false
})
export class CpProvisionContractAgentSideComponent extends CpProvisionContractAgentBaseComponent
    implements OnInit {

    ngOnInit() {
        super.ngOnInit();
    }

}
